export default __webpack_public_path__ + "static/media/img_scsc_9.69a37f3c.png";